import React from "react";
import SEO from "../components/seo";
import LayoutPage from "../layouts";

const ContactPage = () => {
  return (
    <LayoutPage>
      <SEO title="contact"> </SEO>
      <div className="contact">
        <h1>Feel free to contact me!</h1>
        <div>
          <form method="POST" action="https://getform.io/f/d70baacc-0e23-441a-bebe-be4a03a57534">
            <div>
              <label id="name">Name</label>
              <br/>
              <input type="text" id="name" name="name" placeholder="Your Name" />
            </div>
            <div>
              <label id="email">Email</label>
              <br/>
              <input type="text" id="email" name="email" placeholder="Your Email" />
            </div>
            <div>
              <label id="message">Message</label>
              <br/>
              <textarea></textarea>
            </div>
            <div>
                <button type="submit">Send</button>
            </div>
          </form>
        </div>
      </div>
    </LayoutPage>
  );
};

export default ContactPage;
